<template>
	<div>
		<my-navBar></my-navBar>
		<div class="carouselBox">
			<el-carousel :interval="5000" arrow="always" class="carousel" height='100%' trigger='click'>
				<el-carousel-item v-for="item in carouselList" :key="item">
					<img :src="item" class="carouselItem">
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 正在热映/即将上映 -->
		<div class="content">
			<div>
				<ul class="hotFlimTab">
					<li :class="curTabIndex==0?'active':''" @click="clickTab(0)">
						正在热映
					</li>
					<li :class="curTabIndex==1?'active':''" @click="clickTab(1)">
						即将上映</li>
					<router-link tag="li" class="more" to="/movie">查看更多</router-link>
				</ul>
				<ul class="hotFlimList" v-if='curTabIndex==0'>
					<li v-for="(item,index) in hotFlim" :key='index' @click="toMvInfo(item.id)">
						<div class="cover">
							<div>
								<img :src="item.cover">
								<div class="name">
									<div class="nameVal">{{item.name}}</div>
								</div>
							</div>
							<div class="black">
								<div class="buyTic">{{item.presell?'预售':'选座购票'}}</div>
							</div>
						</div>
					</li>
				</ul>
				<ul class="hotFlimList commingList" v-if='curTabIndex==1'>
					<li v-for="(item,index) in commingFlim" :key='index' @click="toMvInfo(item.id)">
						<div class="cover">
							<img :src="item.cover">
							<div class="name">
								<div class="nameVal">{{item.name}}</div>
							</div>
						</div>
						<div class="time">上映时间 {{item.date}}</div>
					</li>
				</ul>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'home',
		data() {
			return {
				carouselList: [],
				curTabIndex: 0,
				hotFlim: [],
				commingFlim: [],
			}
		},
		methods: {
			clickTab: function(index) {
				this.curTabIndex = index
			},
			homeAxios: function() {
				//轮播图
				this.axiosSw();
				//热映列表
				this.axiosHotFilms();
				//即将上映
				this.axiosWillOn();
			},
			axiosSw:function(){
				var that = this;
				var vueXInfo = that.$store.state;
				that.axios.post('/resUrl/api/pub/getSliders', {
						group_id: vueXInfo.group_id,
						city: vueXInfo.selCityInfo.region_name ? vueXInfo.selCityInfo.region_name : ''
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var sliders = res.data.content.sliders;
							var arr = [];
							for (var i = 0; i < sliders.length; i++) {
								var item = that.$store.state.resUrl + sliders[i].picture;
								arr.push(item)
							}
							if (arr.length == 0) {
								arr.push(require('@/assets/img/default.png'));
							}
							that.carouselList = arr;
						}
					})
			},
			axiosHotFilms:function(){
				var that = this;
				//正在热映
				that.axios.post('/resUrlTB/api/v2/getHotFilms', {
						group_id: that.$store.state.group_id,
						city_name: that.$store.state.selCityInfo.region_name
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var resHot_films = res.data.content.hot_films;
							var arr = [];
							for (var i = 0; i < resHot_films.length; i++) {
								if(arr.length==15){
									break;
								}
								var item = {
									cover: resHot_films[i].trailer_cover,
									id: resHot_films[i].id,
									name: resHot_films[i].film_name
								}
								arr.push(item);
							}
							that.hotFlim = arr;
						}
					})
			},
			axiosWillOn:function(){
				var that = this;
				that.axios.post('/resUrlTB/api/v2/getSoonFilms', {
						lng: that.$store.state.lng,
						lat: that.$store.state.lat,
						group_id: that.$store.state.group_id,
						city_name: that.$store.state.selCityInfo.region_name
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var movie = res.data.content.wanna_see_movies;
							var arr = [];
							for (var i = 0; i < movie.length; i++) {
								if(arr.length==15){
									break;
								}
								var item = {
									cover: movie[i].trailer_cover,
									date: that.global.getTime(movie[i].start_time),
									id: movie[i].id,
									name: movie[i].film_name
								}
								arr.push(item)
							}
							that.commingFlim = arr;
						}
					})
			},
			toMvInfo: function(show_id) {
				this.$router.push({
					path: '/mvInfo',
					query: {
						show_id
					}
				})
			}
		},
		created: function() {
			var that = this;

			clearInterval(waitGPS)
			var waitGPS = setInterval(function() {
				if (that.$store.state.selCityInfo.region_name) {
					that.homeAxios();
					clearInterval(waitGPS)
				}
			}, 300)
		}
	}
</script>

<style scoped src='@/assets/css/home.css'>

</style>
